import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-policychange-common-react';
import { WMICPolicyRenewalQuote } from 'wmic-pe-capability-gateway-policyrenewal-common-react';
import { WMICPCPAInsuranceHistoryPage } from 'wmic-pe-capability-gateway-policychange-pa-react';
import WMICPRPAVehiclesPage from './pages/Vehicles/WMICPRPAVehiclesPage';
import WMICPAPolicyRenewalCoveragesPage from './pages/WMICPAPolicyRenewalCoverages/WMICPAPolicyRenewalCoveragesPage';
import WMICPAPolicyRenewalDriversDetailsPage from './pages/WMICPAPolicyRenewalDrivers/WMICPAPolicyRenewalDriversDetailsPage';
import WMICPAPolicyRenewalPolicyDetailsPage from './pages/PolicyDetails/WMICPAPolicyRenewalPolicyDetailsPage';

import WMICPARenewalInsuranceHistoryPage from './pages/InsuranceHistory/WMICPARenewalInsuranceHistoryPage';

setComponentMapOverrides(
    {
        WMICPAPolicyRenewalPolicyDetailsPage: { component: 'WMICPAPolicyRenewalPolicyDetailsPage' },
        WMICPAPolicyRenewalDriversDetailsPage: { component: 'WMICPAPolicyRenewalDriversDetailsPage' },
        WMICPRPAVehiclesPage: { component: 'WMICPRPAVehiclesPage' },
        WMICPAPolicyRenewalCoveragesPage: { component: 'WMICPAPolicyRenewalCoveragesPage' },
        WMICPCPAInsuranceHistoryPage: { component: 'WMICPCPAInsuranceHistoryPage' },
        WMICPARenewalInsuranceHistoryPage: { component: 'WMICPARenewalInsuranceHistoryPage' },
        WMICPolicyRenewalQuote: { component: 'WMICPolicyRenewalQuote' },
    },
    {
        WMICPAPolicyRenewalPolicyDetailsPage,
        WMICPAPolicyRenewalDriversDetailsPage,
        WMICPRPAVehiclesPage,
        WMICPAPolicyRenewalCoveragesPage,
        WMICPCPAInsuranceHistoryPage,
        WMICPARenewalInsuranceHistoryPage,
        WMICPolicyRenewalQuote,
    }
);

export { default as PARenewalMessages } from './WMICPEPARenewalWizard.messages';
export { default as WMICPEPARenewalWizard } from './WMICPEPARenewalWizard';
